import * as types from './types';
import { loading } from 'State/actions';
import { toastType, createToast } from 'Common/ToastHelper';
import { has } from 'lodash';

export const getReport = data => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.LETTER_HISTORY_FETCHING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Reports/LetterHistoryReport',
        data
      );

      if (!response.data.Data) {
        createToast(toastType.info, 'Results', 'No data found!', true);
      } else {
        dispatch({
          type: types.LETTER_HISTORY_REPORT,
          payload: response.data.Data,
        });
      }
    } catch (error) {
      if (has(error, 'response.data.Errors')) {
        dispatch({
          type: types.LETTER_HISTORY_FETCH_ERROR,
          payload: error.response.data.Errors,
        });
      }
    }

    dispatch(loading(types.LETTER_HISTORY_FETCHING, false));
  };
};

export const getLetterTemplates = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(
        loading(types.LETTER_HISTORY_GET_LETTER_TEMPLATES_LOADING, true)
      );
      const response = await MPWWebApi.getGeneric('Letter/GetAllTemplates');
      if (!response.data.Data) {
        createToast(toastType.info, 'Results', 'No data found!', true);
      } else {
        dispatch({
          type: types.LETTER_HISTORY_GET_LETTER_TEMPLATES,
          payload: response.data.Data,
        });
      }
    } catch (error) {
      if (has(error, 'response.data.Errors')) {
        dispatch({
          type: types.LETTER_HISTORY_FETCH_ERROR,
          payload: error.response.data.Errors,
        });
      }
    } finally {
      dispatch(
        loading(types.LETTER_HISTORY_GET_LETTER_TEMPLATES_LOADING, false)
      );
    }
  };
};

export const clearReport = () => {
  return {
    type: types.LETTER_HISTORY_REPORT,
    payload: null,
  };
};

export const fetchStudents = props => {
  const {
    studentTableState,
    selectedStatuses,
    selectedLetters,
    selectedSiteId,
    toDate,
    fromDate,
  } = props;

  let data = {
    Filter: studentTableState.filtered.map(filter => {
      return { filterName: filter.id, filterValue: filter.value };
    }),
    PageNumber: studentTableState.page + 1,
    PageSize: studentTableState.pageSize,
    CurrentStatuses: selectedStatuses,
    SiteId: selectedSiteId,
    FromDate: fromDate,
    ToDate: toDate,
    LetterTypes: selectedLetters,
    SortColumn: studentTableState.sorted.map(sort => {
      return { sortName: sort.id, sortDirection: sort.desc ? 'desc' : 'asc' };
    }),
  };

  return async (dispatch, getState, MPWWebApi) => {
    dispatch({
      type: types.LETTER_HISTORY_STUDENTS_LOADING,
      payload: true,
    });

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Student/GetStudentsForLetterHistory',
        data
      );
      dispatch({
        type: types.LETTER_HISTORY_FETCH_STUDENTS,
        payload: response.data.Data,
      });

      dispatch({
        type: types.LETTER_HISTORY_STUDENTS_LOADING,
        payload: false,
      });
    } catch (e) {}
  };
};

export const clearStudents = () => {
  return {
    type: types.LETTER_HISTORY_CLEAR_STUDENTS,
  };
};

export const clearErrors = () => {
  return {
    type: types.LETTER_HISTORY_CLEAR_ERRORS,
  };
};



// WEBPACK FOOTER //
// ./src/pages/letterhistoryreport/state/letterhistoryreport/actions.js